import { atom, useAtom } from 'jotai';
import { Reunion } from '@teetsh/app/src/types/reunions';
import startOfMinute from '@teetsh/app/src/utils/time/startOfMinute';
import { startOfHour } from 'date-fns';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useLimitReached } from '@teetsh/app/src/components/LimitReached/useLimitReached';
import { useCheckPlannerLimit } from '@teetsh/app/src/queries/reunions/useCheckPlannerLimit';

export type IReunionPayloadType = Omit<Reunion, 'categoryId' | 'id'> & {
  categoryId: null | string;
  id?: string;
};

interface Payload {
  reunion?: IReunionPayloadType;
}

export const reunionModalPayload = atom<Payload | undefined>(undefined);

export default function useReunionModal() {
  const [modalPayload, setModalPayload] = useAtom(reunionModalPayload);
  const { access } = useUser();
  const checkPlannerLimit = useCheckPlannerLimit();
  const { openLimitModal } = useLimitReached();
  return {
    isOpen: !!modalPayload,
    openReunionModal: (v: Payload) => setModalPayload(v),
    openNewReunionModal: async (categoryId: string | null, date?: Date) => {
      if (!access.hasAccessToReunions) {
        try {
          await checkPlannerLimit();
        } catch (err: any) {
          if (err?.response?.status === 403) {
            return openLimitModal({
              requiredPlan: err?.response?.data?.requiredPlan,
              limit: err?.response?.data?.limit,
            });
          }
        }
      }
      return setModalPayload({
        reunion: {
          name: '',
          categoryId,
          date: startOfMinute(startOfHour(date || new Date())),
          lastingInMinutes: 60,
          attachments: [],
        },
      });
    },
    closeModal: () => setModalPayload(undefined),
    payload: modalPayload,
  };
}
